export const ROLE_LABELS = {
  customer: "عميل",
  workshop: "ورشة",
  tow_provider: "مقدم سطحة",
  admin: "الإدارة",
  support: "خدمة العملاء",
};

export const TICKET_STATUS = {
  open: { label: "مفتوحة", cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  in_progress: { label: "قيد المعالجة", cls: "bg-blue-500/10 text-blue-700 border-blue-500/30" },
  closed: { label: "مغلقة", cls: "bg-muted text-muted-foreground border-border" },
};

export const REQUEST_STATUSES = [
  "new", "quoted", "workshop_selected", "awaiting_vehicle",
  "inspecting", "repairing", "ready", "delivered", "closed",
];

export const STATUS_LABELS = {
  new: "طلب جديد",
  quoted: "عروض أسعار",
  workshop_selected: "تم اختيار الورشة",
  awaiting_vehicle: "بانتظار وصول المركبة",
  inspecting: "قيد الفحص",
  repairing: "قيد الإصلاح",
  ready: "جاهزة",
  delivered: "تم التسليم",
  closed: "مغلق",
  requested: "طلب سطحة",
  accepted: "تم قبول الطلب",
  driver_on_way: "السائق في الطريق",
  arrived: "وصلت السطحة",
  loaded: "تم تحميل المركبة",
  on_way_to_workshop: "في الطريق للورشة",
  delivered_tow: "تم التسليم",
};

export const TOW_STATUSES = [
  "requested", "accepted", "driver_on_way", "arrived",
  "loaded", "on_way_to_workshop", "delivered",
];

export const SERVICE_TYPES = [
  "ميكانيكا", "كهرباء", "سمكرة ودهان", "تكييف", "كمبيوتر السيارة",
  "إطارات وفرامل", "زجاج", "صيانة دورية",
];

export const CITIES = [
  "الرياض", "جدة", "مكة المكرمة", "المدينة المنورة", "الدمام", "الخبر", "الظهران",
  "الأحساء", "الهفوف", "القطيف", "الجبيل", "حفر الباطن", "الخرج", "المجمعة", "الزلفي",
  "الدوادمي", "شقراء", "وادي الدواسر", "الطائف", "ينبع", "رابغ", "القنفذة", "الليث",
  "بريدة", "عنيزة", "الرس", "المذنب", "تبوك", "حائل", "أبها", "خميس مشيط", "بيشة",
  "محايل عسير", "النماص", "نجران", "جازان", "صبيا", "أبو عريش", "صامطة", "الباحة",
  "بلجرشي", "عرعر", "رفحاء", "سكاكا", "القريات", "دومة الجندل", "العلا", "الدرعية",
];

export const TOW_TYPES = ["عادية", "هيدروليك", "ونش رافعة", "سطحة مغلقة"];

export const STATUS_COLORS = {
  new: "bg-blue-500/10 text-blue-600 border-blue-500/20",
  quoted: "bg-indigo-500/10 text-indigo-600 border-indigo-500/20",
  workshop_selected: "bg-violet-500/10 text-violet-600 border-violet-500/20",
  awaiting_vehicle: "bg-amber-500/10 text-amber-600 border-amber-500/20",
  inspecting: "bg-cyan-500/10 text-cyan-600 border-cyan-500/20",
  repairing: "bg-orange-500/10 text-orange-600 border-orange-500/20",
  ready: "bg-emerald-500/10 text-emerald-600 border-emerald-500/20",
  delivered: "bg-green-500/10 text-green-600 border-green-500/20",
  closed: "bg-slate-500/10 text-slate-600 border-slate-500/20",
  requested: "bg-orange-500/10 text-orange-600 border-orange-500/20",
  accepted: "bg-violet-500/10 text-violet-600 border-violet-500/20",
  driver_on_way: "bg-blue-500/10 text-blue-600 border-blue-500/20",
  arrived: "bg-cyan-500/10 text-cyan-600 border-cyan-500/20",
  loaded: "bg-amber-500/10 text-amber-600 border-amber-500/20",
  on_way_to_workshop: "bg-indigo-500/10 text-indigo-600 border-indigo-500/20",
};

export function roleHome(role) {
  return { customer: "/app", workshop: "/workshop", tow_provider: "/tow", admin: "/admin", support: "/support-desk" }[role] || "/";
}
